import React from 'react';

const DrumstickIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="m15.4 9.5 3.9-3.9a2.5 2.5 0 1 0-3.5-3.5l-3.9 3.9" />
    <path d="M18.3 12.2a2.5 2.5 0 1 1-3.5-3.5l-3.9 3.9A2.5 2.5 0 1 1 7.4 9.1l3.9-3.9" />
    <path d="M10.2 13.5c-4.8 3.3-5.9 8.6-5.6 10l4.3-1.8c.3.3.8.3 1.1 0l7.5-7.5c.3-.3.3-.8 0-1.1L13.5 9.1" />
  </svg>
);

export default DrumstickIcon;